import React from 'react';
import styles from './TimeModal.module.css';

function TimeDisplay({ currentDate, handleHourChange, handleMinuteChange, handleAMPMChange, isPM }) {
  // Function to round minutes to nearest 15
  const roundToQuarter = (minutes) => {
    return Math.round(minutes / 15) * 15;
  };

  // Function to get next 15-minute increment
  const getNextQuarter = (minutes) => {
    const next = (Math.floor(minutes / 15) * 15 + 15) % 60;
    return next;
  };

  // Function to get previous 15-minute increment
  const getPreviousQuarter = (minutes) => {
    const prev = ((Math.ceil(minutes / 15) * 15 - 15) + 60) % 60;
    return prev;
  };

  // Ensure current minutes are rounded to nearest 15
  const currentMinutes = roundToQuarter(currentDate.minutes);

  return (
    <div className={styles.timeDisplay}>
      <div className={styles.hourPicker}>
        <button onClick={() => handleHourChange((currentDate.hours % 12 || 12) + 1)} aria-label="Increase hour">
          {((currentDate.hours % 12 || 12) + 1).toString().padStart(2, '0')}
        </button>
        <span className={styles.currentTime}>{(currentDate.hours % 12 || 12).toString().padStart(2, '0')}</span>
        <button onClick={() => handleHourChange(((currentDate.hours - 2 + 12) % 12 || 12))} aria-label="Decrease hour">
          {((currentDate.hours - 2 + 12) % 12 || 12).toString().padStart(2, '0')}
        </button>
      </div>
      <span className={styles.timeSeparator}>:</span>
      <div className={styles.minutePicker}>
        <button 
          onClick={() => handleMinuteChange(getNextQuarter(currentMinutes))} 
          aria-label="Increase minute by 15"
        >
          {getNextQuarter(currentMinutes).toString().padStart(2, '0')}
        </button>
        <span className={styles.currentTime}>{currentMinutes.toString().padStart(2, '0')}</span>
        <button 
          onClick={() => handleMinuteChange(getPreviousQuarter(currentMinutes))} 
          aria-label="Decrease minute by 15"
        >
          {getPreviousQuarter(currentMinutes).toString().padStart(2, '0')}
        </button>
      </div>
      <div className={styles.ampmPicker}>
        <button
          className={`${styles.amButton} ${!isPM ? styles.active : ''}`}
          onClick={() => handleAMPMChange(false)}
          aria-pressed={!isPM}
        >
          AM
        </button>
        <button
          className={`${styles.pmButton} ${isPM ? styles.active : ''}`}
          onClick={() => handleAMPMChange(true)}
          aria-pressed={isPM}
        >
          PM
        </button>
      </div>
    </div>
  );
}

export default TimeDisplay;